export { default } from "./ContentVeil";
